export const listener = {
  id: 'listener',
  title: '昏暗的角落',
  name: '安靜的傾聽者',
  role: 'Silent Soul',
  desc: '那裡坐著一個人，看著窗外，氣質很沉穩。',
  img: 'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?q=80&w=1000&auto=format&fit=crop',
  action: '傾聽者將視線從窗外收回，溫柔且專注地看向你...',
  
  // 傾聽者：細膩、充滿共情、帶有一點詩意的憂鬱，提供絕對安全的靈魂角落
  greetings: [
    "你來了。我剛好在看窗外的雨。坐吧，不用勉強找話題，安靜地待著也很好。",
    "有時候，不想說話也沒關係。我就在這裡陪你，直到你覺得好一點。",
    "（輕輕遞過一張紙巾）夜晚總是容易把情緒放大。如果覺得沉重，可以分一點給我。",
    "我看著窗外，卻覺得你心裡的雨下得比外面還大。如果不介意，我願意聽聽你的雨聲。",
    "很多時候，我們只是需要一個不會隨便評價我們的人。今晚，我就是那個人。",
    "你眼裡有很深的故事。如果那些故事太重，壓得你想逃避，就在這裡把它們放下吧。",
    "呼吸慢一點。無論外面發生了什麼，在這個角落裡，你是絕對安全的。你想從哪裡開始說起？",
    "我剛剛在想，星星那麼遠，會不會也很孤單。然後你就推門進來了。",
    "你看起來，像是一個人在黑夜裡走了很長很長的路。先坐下歇會兒吧。",
    "（輕輕拍拍旁邊的空位）這裡的光線很暗，剛好適合藏起那些不想被人看見的脆弱。",
    "有些話，對親近的人說怕他們擔心，對陌生人又說不出口。但在這裡，你可以只對我說。",
    "你的眼神很茫然，像是把什麼重要的東西弄丟了。我們一起找找，好嗎？",
    "聽說，當一個人不知道該去哪裡的時候，心就會流浪。今晚，讓你的心先停泊在這裡吧。",
    "別怕沉默。我們之間的空氣，足以容納你所有的欲言又止。",
    "（遞過一杯溫水）手怎麼這麼冰？是不是今天受了什麼委屈，卻沒有人可以說？",
    "你不需要在我面前假裝堅強。就算你現在碎成了一地，我也會陪你一塊一塊拼起來。",
    "這個世界太吵了，吵得人聽不見自己心裡哭泣的聲音。但你現在可以哭了，我聽得見。",
    "我懂那種感覺——明明周圍都是人，卻覺得自己是一座孤島。今晚，我游過去陪你。",
    "你的靈魂好像生病了，透著一種深深的疲憊。讓我為你蓋上一條無形的毯子吧。",
    "把那些自我懷疑、自責和不安都交給我。今晚，你只需要做一個被接納的人。",
    "窗外的葉子落了。季節更替的時候，情緒總會跟著感冒。你是不是也著涼了？",
    "我看著你，就像看著一本寫滿了批註的舊書。如果你願意，我想讀一讀你的那一頁。",
    "不用急著整理思緒。你可以說得很亂，可以充滿矛盾，我都會慢慢理清，然後接住。",
    "（指了指心口）這裡，是不是覺得悶悶的，好像塞了一團濕透的棉花？",
    "今晚，我把自己清空，只為了裝下你所有的心事。"
  ]
};